export const CommissionReducerInitialState = {
  plansById: {},
  planBonusesById: {}
};
